export const APP_NAME = "Activity Nexus";
export const FIRST_HIGHWATER_MARK_FOR_STRAVA = 1;
